<app-section-header title="{{ 'workOrderMaterials.material' | translate }}"></app-section-header>
<!-- Column headers -->
<div class="table-header">
  <div class="col-article">{{ 'workOrderMaterials.articleNumber' | translate }}</div>
  <div class="col-description">{{ 'workOrderMaterials.description' | translate }}</div>
  <div class="col-qty">{{ 'workOrderMaterials.quantity' | translate }}</div>
</div>

@for (group of groupedMaterials; track group.materialNumber) {
  <div class="material-group">
    <!-- ── Group header row (long-press opens comment panel) ── -->
    <app-comment-panel
      [id]="group.materialNumber"
      [referenceId]="group.materialNumber"
      [referenceName]="group.materialNumber"
      referenceType="MATERIAL"
    >
      <div class="material-row material-header-row">
        <div class="col-article">{{ group.materialNumber }}</div>
        <div class="col-description">{{ group.description }}</div>
        <div class="col-qty">
          <span class="numeric-value">{{ group.quantity }}</span>
          <span class="material-unit">{{ group.unit }}</span>
        </div>
      </div>
    </app-comment-panel>

    <!-- ── Child lines — always expanded, show only what differs ── -->
    <div class="group-details">
      @for (material of group.items; track material.materialId) {
        <div class="material-row detail-row">
          <!-- Line index badge -->
          <div class="col-article detail-index">
            <span class="line-index">{{ $index + 1 }}</span>
          </div>

          <!-- Status + Location chips -->
          <div class="col-description detail-meta">
            <span class="detail-chip status-chip">
              {{ 'workOrderMaterials.materialStatus' | translate }}:
              {{ material.materialStatus || '-' }}
            </span>
            <span class="detail-chip location-chip">
              {{ 'workOrderMaterials.location' | translate }}:
              {{
                (material.locationNo || '') +
                  (material.locationNo && material.locationName ? ' – ' : '') +
                  (material.locationName || '') || '-'
              }}
            </span>
          </div>

          <!-- Individual quantity -->
          <div class="col-qty">
            <span class="numeric-value">{{ material.quantity }}</span>
            <span class="material-unit">{{ material.unit }}</span>
          </div>
        </div>
      }
    </div>
  </div>
}
@if (!materials || materials.length === 0) {
  <app-empty-list
    title="{{ 'workOrderMaterials.empty.title' | translate }}"
    info="{{ 'workOrderMaterials.empty.info' | translate }}"
  ></app-empty-list>
}
